import { NoData } from '@saucelabs/ds-data-states';
import { IconImageOutline } from '@saucelabs/ds-icons';
import { Loader } from '@saucelabs/sl-component-loader';
import React from 'react';

type Props = {
  isRunning: boolean
}

const DiffNoData: React.FC<Props> = ({ isRunning }) => (
  <div className="flex justify-center mt-8">
    <div className="flex flex-col items-center">
      {isRunning ? (
        <NoData
          className="px-4"
          description="Snapshots will appear here as the build progresses. Is it taking too long? Check the configuration of your tests."
          icon={Loader}
          spacing="small"
          title="The build is executing in real time"
        />
      ) : (
        <NoData
          description="Check the configuration of your tests."
          icon={IconImageOutline}
          spacing="small"
          title="There are no snapshots in this build"
        />
      )}
    </div>
  </div>
);

export default DiffNoData;
